import type { MultilinkStoryblok } from "~/types/storyblok";

/**
 * Generates a URL string based on the provided Storyblok multilink field.
 *
 * - Removes trailing slashes and "index" from the URL.
 * - For email links, returns a `mailto:` URL.
 * - For external URLs, ensures the URL is properly prefixed.
 * - For anchor links, returns the anchor as is.
 * - For Storyblok stories, constructs a path with an optional anchor.
 *
 * @param link - The multilink field object from Storyblok.
 * @returns The formatted URL string.
 */
export default function getLinkFieldUrl(link: MultilinkStoryblok): string {
  let url = (link?.cached_url || link?.url || "").trim();
  if(url.length === 0) return "/";

  url = url.replace(/index\/?$/, "").replace(/\/+$/, "");

  if (link.linktype === "email") return `mailto:${url}`;

  if (link.linktype === "url") {
    if (url.startsWith("#")) return `${url}`;
    if (!url.startsWith("/") && !url.startsWith("http") && !url.startsWith("mailto") && !url.startsWith("tel")) url = `/${url}`;
  }

  return link.linktype === "story" ? `/${url}${link.anchor ? `#${link.anchor}` : ""}` : url;
}
